<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="24">
          <Col v-bind="grid">
            <FormItem label="会员卡类型："  label-for="cardType">
              <Select v-model="userForm.cardType" class="perW100" @on-change="onChangeCardType">
                <Option :value="0">全部</Option>
                <Option v-for="item in cardInfos" :value="item.system_card_id" :key="item.system_card_id">
                  {{item.title}}
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="注册时间："  label-for="ctime">
              <DatePicker type="daterange" placement="bottom-end" placeholder="请选择注册时间" style="width: 350px" @on-change="onChange"></DatePicker>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="用户搜索："  label-for="key">
              <Input search enter-button :placeholder="placeholder" v-model="userForm.key" @on-search="userSearchs" :readonly="isDisable">
                <Select v-model="field_key" slot="prepend" style="width: 80px" @on-change="selectChange">
                  <Option value="all">全部</Option>
<!--                  <Option value="phone">手机号</Option>-->
                  <Option value="nickname">用户名称</Option>
                </Select>
              </Input>
            </FormItem>
          </Col>
          <Col  v-bind="grid">
            <Button type="primary" @click="exportData">导出</Button>
          </Col>
        </Row>
      </Form>
      <Table :columns="columns2" :data="userInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="status">
          <i-switch v-model="row.status" :value="row.status" :true-value="1" :false-value="0" @on-change="changeSwitch(row)">
          </i-switch>
        </template>
        <template slot-scope="{ row, index }" slot="type">
          <span v-if="row.type == 1">游客</span>
          <span v-if="row.type == 2">家长</span>
          <span v-if="row.type == 3">老师</span>
          <span v-if="row.type == 4">园长</span>
        </template>
        <template slot-scope="{ row, index }" slot="avatar">
          <div class="tabBox_img">
            <img :src="row.avatar ? row.avatar : require('../../assets/images/avatar.png')">
          </div>
        </template>
<!--        <template slot-scope="{ row, index }" slot="action">-->
<!--&lt;!&ndash;          <a @click="detail(row.user_id)">查看</a>&ndash;&gt;-->
<!--          <Divider type="vertical" />-->
<!--          <template>-->
<!--            <Dropdown @on-click="changeMenu(row,$event,index)">-->
<!--              <a href="javascript:void(0)">-->
<!--                更多-->
<!--                <Icon type="ios-arrow-down"></Icon>-->
<!--              </a>-->
<!--              <DropdownMenu slot="list">-->
<!--                <DropdownItem name="edit">修改</DropdownItem>-->
<!--              </DropdownMenu>-->
<!--            </Dropdown>-->
<!--          </template>-->
<!--        </template>-->
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
    <userAdd :addShow="addShow" :adduserid="adduserid" @updateStatusModel2="updateStatusModel2"></userAdd>
    <userEdit :editShow="editShow" :edituserid="edituserid" @updateStatusModel="updateStatusModel"></userEdit>
    <usershow :formShow="formShow" :id="userid" @updateStatusModel3="updateStatusModel3"></usershow>
    <modalLock ref="modalLock" @closeModal="closeModal"></modalLock>
    <GiveEdit ref="giveEdit" @closeModal="closeModal"></GiveEdit>
    <sendCardEdit ref="sendCardEdit" @closeModal="closeModal"></sendCardEdit>
  </div>
</template>

<script>
import { userList, changeUserStatusApi, exportData, getAllCardInfo } from '@/api/user'
import modalLock from './components/modalLock'
import userAdd from './userAdd'
import userEdit from './userEdit'
import usershow from './components/userEdit'
import excel from '@/libs/excel'
import GiveEdit from './components/giveEdit'
import sendCardEdit from './components/sendCardEdit'
export default {
  name: 'userlist',
  inject: ['reload'],
  components: { userEdit, userAdd, usershow, modalLock, GiveEdit, sendCardEdit },
  data () {
    return {
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      userForm: {
        page: 1,
        limit: 10,
        key: '',
        field_key: '',
        type: 0,
        zx: 0,
        adminzx: 0,
        level: 0,
        cardType: 0,
        ctime: []
      },
      cardInfos: [],
      isDisable: true,
      confirm: false,
      editShow: false,
      formShow: false,
      addShow: false,
      dataCount: 0,
      field_key: 'all',
      userInfo: [],
      loading: false,
      userid: 0,
      edituserid: 0,
      adduserid: 0,
      columns2: [
        {
          title: 'ID',
          key: 'id',
          minWidth: 80
        },
        {
          title: '用户名称',
          key: 'nickname',
          minWidth: 120
        },
        {
          title: '孩子姓名',
          key: 'real_name',
          minWidth: 120
        },
        {
          title: '真实姓名',
          key: 'username',
          minWidth: 120
        },
        {
          title: '头像',
          slot: 'avatar',
          minWidth: 120
        },
        // {
        //   title: '手机号',
        //   key: 'phone',
        //   minWidth: 120
        // },
        {
          title: '会员类型',
          slot: 'type',
          minWidth: 100
        },
        {
          title: '是否启用',
          slot: 'status',
          minWidth: 100
        },
        {
          title: '注册时间',
          key: 'ctime',
          minWidth: 120
        },
        // {
        //   title: '操作',
        //   slot: 'action',
        //   fixed: 'right',
        //   minWidth: 180
        // }
      ]
    }
  },
  created () {
    this.userList()
    this.getAllCardInfo()
  },
  activated () {
    this.userList()
  },
  methods: {
    userList () {
      this.loading = true
      this.userForm.field_key = this.field_key === 'all' ? '' : this.field_key
      userList(this.userForm).then(res => {
        let data = res.data
        this.userInfo = data.list
        this.dataCount = data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changepage (status) {
      this.userForm.page = status
      this.userList()
    },
    // 表格搜索
    userSearchs () {
      this.userForm.page = 1
      this.userList()
    },
    selectChange (val) {
      if (val === 'all') {
        this.isDisable = true
        this.placeholder = '请选择类别'
      } else {
        this.isDisable = false
        this.placeholder = '请输入内容'
      }
      this.userForm.key = ''
    },
    // 上下架
    changeSwitch (row) {
      let data = { id: row.user_id }
      changeUserStatusApi(data).then(async res => {
        this.$Message.success(res.msg)
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    detail (id) {
      this.userid = id
      this.formShow = true
    },
    edit (row) {
      if (row.is_admin_official_auth === 1) {
        this.adduserid = row.user_id
        this.addShow = true
      } else {
        this.edituserid = row.user_id
        this.editShow = true
      }
    },
    updateStatusModel (modalStatus) {
      this.editShow = modalStatus
      this.userList()
    },
    updateStatusModel2 (modalStatus) {
      this.addShow = modalStatus
      this.userList()
    },
    updateStatusModel3 (modalStatus) {
      this.formShow = modalStatus
      this.userList()
    },
    add () {
      this.addShow = true
    },
    unlock (row) {
      this.$refs.modalLock.isShow = true
      this.$refs.modalLock.card_id = row.cardId
    },
    closeModal () {
      this.userList()
    },
    onChangeType (val) {
      this.userForm.type = val
      this.userList()
    },
    onChangeZx (val) {
      this.userForm.zx = val
      this.userList()
    },
    onChangeAdminzx (val) {
      this.userForm.adminzx = val
      this.userList()
    },
    onChangeLevel (val) {
      this.userForm.level = val
      this.userList()
    },
    onChangeCardType (val) {
      this.userForm.cardType = val
      this.userList()
    },
    exportData () {
      exportData(this.userForm).then(res => {
        let data = res.data
        // console.log(data);return;
        if (data.length) {
          this.exportLoading = true
          const params = {
            title: ['用户名称', '真实姓名', '手机号', '邀请码', '会员卡类型', '卡有效期', '冻结状态', '冻结时间', '是否甄选家',
              '是否官方甄选家', '甄选家等级', '可用积分', '海星', '已住多少晚', '注册时间'],
            key: ['nickname', 'realName', 'phone', 'invitation_code', 'cardName', 'validity', 'freeze_status',
              'freeze_time', 'is_official_auth', 'is_admin_official_auth', 'office_level', 'integral', 'starfish', 'homes_checkIn_num', 'ctime'],
            data: data,
            autoWidth: true,
            filename: '用户管理'
          }
          excel.export_array_to_excel(params)
          this.exportLoading = false
        } else {
          this.$Message.info('表格数据不能为空！')
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    getAllCardInfo () {
      getAllCardInfo().then(async res => {
        this.cardInfos = res.data
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    onChange (val) {
      this.userForm.ctime = val
      this.userList()
    },
    sendCoupon (row) {
      this.$refs.giveEdit.isShow = true
      this.$refs.giveEdit.formInfo.user_id = row.user_id
    },
    sendCard (row) {
      this.$refs.sendCardEdit.isShow = true
      this.$refs.sendCardEdit.init()
      this.$refs.sendCardEdit.formInfo.user_id = row.user_id
    },
    changeMenu (row, name) {
      switch (name) {
        case 'edit':
          this.edit(row)
          break
        default:
      }
    }
  }
}
</script>
